import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  standalone: false,
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent implements OnInit, OnDestroy {
  savedTab: any =
    sessionStorage.getItem(btoa('primeContractorUserHomeSelectedTab')) ?? '';
  selectedItem: 'jobs' | 'incidents' | 'sites' | 'checkpoint-scans' = [
    'jobs',
    'incidents',
    'sites',
    'checkpoint-scans',
  ].includes(this.savedTab)
    ? this.savedTab
    : 'jobs';
  constructor(private router: Router) {}
  ngOnDestroy() {}
  ngOnInit() {}

  changeTab(selectedTab: 'jobs' | 'incidents' | 'sites' | 'checkpoint-scans') {
    this.router.navigate(['/pc'], {
      replaceUrl: true, // Replaces the current URL without adding a new history entry
    });
    this.selectedItem = selectedTab;
    sessionStorage.setItem(
      btoa('primeContractorUserHomeSelectedTab'),
      selectedTab,
    );
  }
  selectDropDown(event: any) {
    const selectedItem = event?.target?.value;
    this.changeTab(selectedItem);
  }
}
